import React, { useState, useEffect } from "react";
import { FaRunning } from "react-icons/fa";
import { MdSportsCricket } from "react-icons/md";
import { GiCricketBat } from "react-icons/gi";
import { BsCurrencyDollar } from "react-icons/bs";
import { GoPrimitiveDot } from "react-icons/go";
import { IoIosMore } from "react-icons/io";
import { IoIosRefresh } from "react-icons/io";

import { GrStatusGood } from "react-icons/gr";
const Loader = () => {
  return (
    <div className="flex items-center justify-center h-screen">
    <div className="loader"> <svg role="img" aria-label="Mouth and eyes come from 9:00 and rotate clockwise into position, right eye blinks, then all parts rotate and merge into 3:00" class="smiley" viewBox="0 0 128 128" width="128px" height="128px">
<defs>
<clipPath id="smiley-eyes">
<circle class="smiley__eye1" cx="64" cy="64" r="8" transform="rotate(-40,64,64) translate(0,-56)" />
<circle class="smiley__eye2" cx="64" cy="64" r="8" transform="rotate(40,64,64) translate(0,-56)" />
</clipPath>
<linearGradient id="smiley-grad" x1="0" y1="0" x2="0" y2="1">
<stop offset="0%" stop-color="#000" />
<stop offset="100%" stop-color="#fff" />
</linearGradient>
<mask id="smiley-mask">
<rect x="0" y="0" width="128" height="128" fill="url(#smiley-grad)" />
</mask>
</defs>
<g stroke-linecap="round" stroke-width="12" stroke-dasharray="175.93 351.86">
<g>
<rect fill="hsl(193,90%,50%)" width="128" height="64" clip-path="url(#smiley-eyes)" />
<g fill="none" stroke="hsl(193,90%,50%)">
    <circle class="smiley__mouth1" cx="64" cy="64" r="56" transform="rotate(180,64,64)" />
    <circle class="smiley__mouth2" cx="64" cy="64" r="56" transform="rotate(0,64,64)" />
</g>
</g>
<g mask="url(#smiley-mask)">
<rect fill="hsl(223,90%,50%)" width="128" height="64" clip-path="url(#smiley-eyes)" />
<g fill="none" stroke="hsl(223,90%,50%)">
    <circle class="smiley__mouth1" cx="64" cy="64" r="56" transform="rotate(180,64,64)" />
    <circle class="smiley__mouth2" cx="64" cy="64" r="56" transform="rotate(0,64,64)" />
</g>
</g>
</g>
</svg></div>
</div>
  )
}
//sample API response
const dataSample = [
  {
    "id": "043bb613-d8ee-4287-9ccb-a298a0f9c389",
    "dateTimeGMT": "2026-06-01T14:00:00",
    "matchType": "t20",
    "status": "Match Completed",
    "series": "TATA IPL 2026",
    "venue": "Narendra Modi Stadium, Ahmedabad",
    "result": "Royal Challengers Bengaluru Won by 6 Wickets",
    "ms": "completed",
    "t1": "Royal Challengers Bengaluru [RCB]",
    "t2": "Gujarat Titans [GT]",
    "t1s": "161/5 (18)",
    "t2s": "155/8 (20)",
    "t1img": "https://g.cricapi.com/iapi/135-637852956181378533.png?w=48",
    "t2img": "https://g.cricapi.com/iapi/21439-638468478038395955.jpg?w=48",
  }
]
const LiveScore = () => {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);

  const teamCaptains = {
    "Chennai Super Kings [CSK]":
      "https://documents.iplt20.com/ipl/IPLHeadshot2024/57.png",
    "Royal Challengers Bengaluru [RCB]":
      "https://documents.iplt20.com/ipl/IPLHeadshot2025/597.png",
    "Mumbai Indians [MI]":
      "https://documents.iplt20.com/ipl/IPLHeadshot2024/54.png",
    "Rajasthan Royals [RR]":
      "https://documents.iplt20.com/ipl/IPLHeadshot2024/190.png",
    "Sunrisers Hyderabad [SRH]":
      "https://documents.iplt20.com/ipl/IPLHeadshot2024/33.png",
    "Kolkata Knight Riders [KKR]":
      "https://documents.iplt20.com/ipl/IPLHeadshot2024/12.png",
    "Lucknow Super Giants [LSG]":
      "https://documents.iplt20.com/ipl/IPLHeadshot2024/19.png",
    "Gujarat Titans [GT]":
      "https://documents.iplt20.com/ipl/IPLHeadshot2024/62.png",
    "Delhi Capitals [DC]":
      "https://documents.iplt20.com/ipl/IPLHeadshot2024/18.png",
    "Punjab Kings [PBKS]":
      "https://documents.iplt20.com/ipl/IPLHeadshot2025/12.png",
  };

  const teamLogos = {
    "Chennai Super Kings [CSK]":
      "https://scores.iplt20.com/ipl/teamlogos/CSK.png",
    "Royal Challengers Bengaluru [RCB]":
      "https://scores.iplt20.com/ipl/teamlogos/aFPMviEPyJ1710927747rcb.png",
    "Mumbai Indians [MI]": "https://scores.iplt20.com/ipl/teamlogos/MI.png",
    "Rajasthan Royals [RR]": "https://scores.iplt20.com/ipl/teamlogos/RR.png",
    "Sunrisers Hyderabad [SRH]":
      "https://scores.iplt20.com/ipl/teamlogos/SRH.png",
    "Kolkata Knight Riders [KKR]":
      "https://scores.iplt20.com/ipl/teamlogos/KKR.png",
    "Lucknow Super Giants [LSG]":
      "https://scores.iplt20.com/ipl/teamlogos/gPLvfvSC1X1711457972LSG.png",
    "Gujarat Titans [GT]": "https://scores.iplt20.com/ipl/teamlogos/GT.png",
    "Delhi Capitals [DC]": "https://scores.iplt20.com/ipl/teamlogos/DC.png",
    "Punjab Kings [PBKS]": "https://scores.iplt20.com/ipl/teamlogos/PBKS.png",
  };

  // useEffect(() => {
  //   const fetchLiveScore = async () => {
  //     try {
  //       const response = await fetch("/api/livescore");
  //       const data = await response.json();
  //       setMatches(data);
  //       setLoading(false);
  //     } catch (error) {
  //       console.error("Error fetching live score:", error);
  //     }
  //   };

  //   fetchLiveScore();
  // }, []);
  useEffect(() => {
    const fetchLiveScore = async () => {
      try {
     
        setMatches(dataSample);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching live score:", error);
      }
    };

    fetchLiveScore();
  }, []);

  const calculateRunRate = (scoreString) => {
    const [runsString, oversString] = scoreString.split("/");
    const runsScored = parseInt(runsString);

    let oversPlayed;

    if (oversString.includes("(")) {
      const match = oversString.match(/\((\d+(\.\d+)?)\)/);
      oversPlayed = match ? parseFloat(match[1]) : NaN;
    } else {
      oversPlayed = parseFloat(oversString);
    }

    if (isNaN(oversPlayed) || oversPlayed === 0 || isNaN(runsScored)) {
      return "N/A";
    }
    const runRate = runsScored / oversPlayed;
    return runRate.toFixed(2);
  };

  const calculateStrikeRate = (scoreString) => {
    const [runsString, oversString] = scoreString.split("/");
    const runsScored = parseInt(runsString);

    let oversPlayed;

    if (oversString.includes("(")) {
      const match = oversString.match(/\((\d+(\.\d+)?)\)/);
      oversPlayed = match ? parseFloat(match[1]) : NaN;
    } else {
      oversPlayed = parseFloat(oversString);
    }

    if (isNaN(oversPlayed) || oversPlayed === 0 || isNaN(runsScored)) {
      return "N/A";
    }
    const ballsFaced = oversPlayed * 6;
    const strikeRate = (runsScored / ballsFaced) * 100;
    return strikeRate.toFixed(2);
  };

  const getWicketsLost = (scoreString) => {
    if (!scoreString) return "0";
    const parts = scoreString.split("/");
    if (parts.length < 2) return "0";
    const wicketsLost = parts[1].trim().split(" ")[0];
    return wicketsLost || "0";
  };

  const handleRefresh = async () => {
    setLoading(true);

    try {
      const response = await fetch("/api/aa");
      const data = await response.json();
      setMatches(data);
    } catch (error) {
      console.error("Error fetching live score:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="mt-48">
          <div className="flex justify-center mb-4 ">
            <button
              type="button"
              onClick={handleRefresh}
              className="flex items-center px-4 py-2 mr-16 font-bold text-white bg-blue-500 rounded hover:bg-blue-700"
            >
              <IoIosRefresh className="mr-2" />
              Refresh
            </button>
          </div>
          <div className="flex-wrap justify-center gap-4 lg:flex">
            {matches.map((match) => (
              <div key={match.id} className="flex flex-wrap justify-center gap-4">
                {/* Team 1 Card */}
                <div className="flex flex-col items-center w-full p-4 bg-white dark:text-gray-200 dark:bg-secondary-dark-bg rounded-xl lg:w-auto h-60 md:w-80 lg:flex-row ">
                  <img
                    src={teamCaptains[match.t1]}
                    className="mb-4 w-72 h-72 drop-shadow-2xl lg:mr-4"
                    alt={match.t1}
                    style={{marginTop:"-10rem"}}
                  />
                  <div className="flex flex-col items-start lg:w-3/4">
                    <p className="mb-2 text-xl font-medium text-black">
                      {match.t1}
                    </p>
                    <div className="flex items-center mb-2">
                      <div className="flex items-center justify-center w-16 h-16 mr-4 border-2 border-blue-400 rounded-full">
                        <img
                          src={teamLogos[match.t1]}
                          className="w-12 h-12 rounded-full"
                          alt="Team Logo"
                        />
                      </div>
                      <div className="text-center">
                        <p className="text-2xl font-bold">
                          {match.t1s}
                        </p>
                        <p className="font-bold text-gray-600">
                          Run-rate: {match.t1s ? calculateRunRate(match.t1s) : "Yet to bat"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Team 2 Card */}
                <div className="flex flex-col items-center w-full p-4 bg-white dark:text-gray-200 dark:bg-secondary-dark-bg rounded-xl lg:w-auto h-60 md:w-80 lg:flex-row ">
                  <div className="flex flex-col items-start lg:w-3/4">
                    <p className="mb-2 text-xl font-medium text-black">
                      {match.t2}
                    </p>
                    <div className="flex items-center mb-2">
                      <div className="flex items-center justify-center w-16 h-16 mr-4 border-2 border-red-800 rounded-full">
                        <img
                          src={teamLogos[match.t2]}
                          className="w-12 h-12 rounded-full"
                          alt="Team Logo"
                        />
                      </div>
                      <div className="text-center">
                        <p className="text-2xl font-bold">
                          {match.t2s || "Yet to bat"}
                        </p>
                        <p className="font-bold text-gray-600">
                          Run-rate: {match.t2s && match.t2s !== "" ? calculateRunRate(match.t2s) : match.t2s ? "Yet to bat" : ""}
                        </p>
                      </div>
                    </div>
                  </div>
                  <img
                    src={teamCaptains[match.t2]}
                    className="mb-4 w-72 h-72 drop-shadow-2xl lg:mr-4"
                    alt={match.t2}
                    style={{marginTop:"-10rem"}}
                  />
                </div>

                {/* Match Info Card */}
                <div className="flex flex-wrap justify-center gap-6 mt-4">
                  <div className="flex flex-col items-center justify-between w-auto p-6 text-center bg-white dark:text-gray-200 dark:bg-secondary-dark-bg rounded-2xl">
                    <div className="mb-2">
                      <span className="font-bold text-gray-700">Series:</span>
                      <span className="ml-2">{match.series}</span>
                    </div>
                    <div className="mb-2">
                      <span className="font-bold text-gray-700">Venue:</span>
                      <span className="ml-2">{match.venue}</span>
                    </div>
                    <div className="mb-2">
                      <span className="font-bold text-gray-700">Result:</span>
                      <span className="ml-2">{match.result}</span>
                    </div>
                  </div>

                  <div className="flex items-center justify-between w-auto p-6 text-center bg-white dark:text-gray-200 dark:bg-secondary-dark-bg rounded-2xl">
                    <button
                      type="button"
                      style={{ color: "#2154bce6", backgroundColor: "#e5fafb" }}
                      className="text-2xl opacity-0.9 rounded-full p-4 hover:drop-shadow-xl"
                    >
                      <GiCricketBat />
                    </button>
                    <div className="text-left">
                      <p className="mt-3 ml-4 text-lg font-semibold">
                        {calculateStrikeRate(match.t1s)}
                      </p>
                      <p className="mt-1 ml-4 text-xl font-bold text-gray-800">
                        Strike Rate
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center justify-between p-6 text-center bg-white dark:text-gray-200 dark:bg-secondary-dark-bg pt-9 rounded-2xl">
                    <button
                      type="button"
                      style={{ color: "#2154bce6", backgroundColor: "#e5fafb" }}
                      className="text-2xl opacity-0.9 rounded-full p-4 hover:drop-shadow-xl"
                    >
                      <GoPrimitiveDot />
                    </button>
                    <div className="text-left">
                      <p className="mt-3 ml-4 text-lg font-semibold">
                        {getWicketsLost(match.t1s)}
                      </p>
                      <p className="mt-1 ml-4 text-xl font-bold text-gray-800">
                        Wickets Lost
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center justify-between p-6 text-center bg-white dark:text-gray-200 dark:bg-secondary-dark-bg pt-9 rounded-2xl">
                    <button
                      type="button"
                      style={{ color: "#2154bce6", backgroundColor: "#e5fafb" }}
                      className="text-2xl opacity-0.9 rounded-full p-4 hover:drop-shadow-xl"
                    >
                      <GrStatusGood />
                    </button>
                    <div className="text-left">
                      <p className="mt-3 ml-4 text-lg font-semibold">
                        {match.status}
                      </p>
                      <p className="mt-1 ml-4 text-xl font-bold text-gray-800">
                        Match Status
                      </p>
                    </div>
                  </div>
                </div>

                {/* Gujarat Titans Batting Scorecard Card */}
                <div className="w-full mt-8">
                  <div className="p-6 bg-white shadow dark:bg-secondary-dark-bg rounded-2xl">
                    <h2 className="mb-4 text-xl font-bold text-center text-blue-700">Gujarat Titans Batting Scorecard</h2>
                    <h2 className="mb-4 text-xl font-bold text-center text-blue-700">Overs (20.0) 155/8</h2>
                    <div className="mb-6 overflow-x-auto">
                      <table className="min-w-full text-sm text-left">
                        <thead>
                          <tr className="bg-blue-100">
                            <th className="px-4 py-2 font-bold">Batter</th>
                            <th className="px-4 py-2 font-bold">How Out</th>
                            <th className="px-4 py-2 font-bold">R</th>
                            <th className="px-4 py-2 font-bold">B</th>
                            <th className="px-4 py-2 font-bold">4s</th>
                            <th className="px-4 py-2 font-bold">6s</th>
                            <th className="px-4 py-2 font-bold">SR</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="px-4 py-2">Sai Sudharsan</td>
                            <td className="px-4 py-2">c Jitesh Sharma b Bhuvneshwar Kumar</td>
                            <td className="px-4 py-2">12</td>
                            <td className="px-4 py-2">12</td>
                            <td className="px-4 py-2">2</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">100.00</td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2">Shubman Gill (c)</td>
                            <td className="px-4 py-2">c Rajat Patidar b Josh Hazlewood</td>
                            <td className="px-4 py-2">10</td>
                            <td className="px-4 py-2">8</td>
                            <td className="px-4 py-2">2</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">125.00</td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2">Nishant Sindhu</td>
                            <td className="px-4 py-2">c Devdutt Padikkal b Rasikh Dar</td>
                            <td className="px-4 py-2">20</td>
                            <td className="px-4 py-2">18</td>
                            <td className="px-4 py-2">3</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">111.11</td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2">Jos Buttler (wk)</td>
                            <td className="px-4 py-2">st Jitesh Sharma b Krunal Pandya</td>
                            <td className="px-4 py-2">19</td>
                            <td className="px-4 py-2">23</td>
                            <td className="px-4 py-2">1</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">82.61</td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2">Washington Sundar</td>
                            <td className="px-4 py-2">not out</td>
                            <td className="px-4 py-2">50</td>
                            <td className="px-4 py-2">37</td>
                            <td className="px-4 py-2">5</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">135.14</td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2">Mohd Arshad Khan</td>
                            <td className="px-4 py-2">c Rasikh Dar b Josh Hazlewood</td>
                            <td className="px-4 py-2">15</td>
                            <td className="px-4 py-2">6</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">2</td>
                            <td className="px-4 py-2">250.00</td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2">Rahul Tewatia</td>
                            <td className="px-4 py-2">c Rajat Patidar b Rasikh Dar</td>
                            <td className="px-4 py-2">7</td>
                            <td className="px-4 py-2">5</td>
                            <td className="px-4 py-2">1</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">140.00</td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2">Jason Holder</td>
                            <td className="px-4 py-2">c Josh Hazlewood b Bhuvneshwar Kumar</td>
                            <td className="px-4 py-2">7</td>
                            <td className="px-4 py-2">5</td>
                            <td className="px-4 py-2">1</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">140.00</td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2">Rashid Khan</td>
                            <td className="px-4 py-2">c Romario Shepherd b Rasikh Dar</td>
                            <td className="px-4 py-2">7</td>
                            <td className="px-4 py-2">3</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">1</td>
                            <td className="px-4 py-2">233.33</td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2">Kagiso Rabada</td>
                            <td className="px-4 py-2">not out</td>
                            <td className="px-4 py-2">3</td>
                            <td className="px-4 py-2">3</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">100.00</td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2 font-bold">Extras</td>
                            <td className="px-4 py-2">(nb 0, w 4, b 0, lb 1, pen 0)</td>
                            <td className="px-4 py-2">5</td>
                            <td className="px-4 py-2"></td>
                            <td className="px-4 py-2"></td>
                            <td className="px-4 py-2"></td>
                            <td className="px-4 py-2"></td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2 font-bold">Did Not Bat:</td>
                            <td className="px-4 py-2" colSpan={6}>Prasidh Krishna, Mohammed Siraj</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    {/* Fall of Wickets */}
                    <h2 className="mt-8 mb-2 text-lg font-bold text-blue-700">Fall of Wickets</h2>
                    <div className="mb-4 text-sm text-gray-800">
                      <ul className="ml-6 list-disc">
                        <li>1-22 Shubman Gill (Over 2.2)</li>
                        <li>2-26 Sai Sudharsan (Over 3.4)</li>
                        <li>3-55 Nishant Sindhu (Over 7.6)</li>
                        <li>4-73 Jos Buttler (Over 12.1)</li>
                        <li>5-99 Mohd Arshad Khan (Over 14.1)</li>
                        <li>6-115 Rahul Tewatia (Over 16.1)</li>
                        <li>7-142 Jason Holder (Over 18.3)</li>
                        <li>8-151 Rashid Khan (Over 19.2)</li>
                      </ul>
                    </div>
                    {/* Partnership Info */}
                    <h2 className="mb-2 text-lg font-bold text-blue-700">Partnerships</h2>
                    <div className="mb-4 text-sm text-gray-800">
                      <ul className="ml-6 list-disc">
                        <li>Shubman Gill 10 (8) &mdash; Partnership: 22 (14), Extras: 3, Sai Sudharsan 9 (6)</li>
                        <li>Sai Sudharsan 3 (6) &mdash; Partnership: 4 (8), Extras: 0, Nishant Sindhu 1 (2)</li>
                        <li>Nishant Sindhu 19 (16) &mdash; Partnership: 29 (26), Extras: 0, Jos Buttler 10 (10)</li>
                        <li>Jos Buttler 9 (13) &mdash; Partnership: 18 (25), Extras: 1, Washington Sundar 8 (12)</li>
                        <li>Washington Sundar 11 (6) &mdash; Partnership: 26 (12), Extras: 0, Mohd Arshad Khan 15 (6)</li>
                        <li>Rahul Tewatia 7 (5) &mdash; Partnership: 16 (12), Extras: 0, Washington Sundar 9 (7)</li>
                        <li>Washington Sundar 19 (9) &mdash; Partnership: 27 (14), Extras: 1, Jason Holder 7 (5)</li>
                        <li>Washington Sundar 2 (2) &mdash; Partnership: 9 (5), Extras: 0, Rashid Khan 7 (3)</li>
                        <li>Washington Sundar 1 (1) &mdash; Partnership: 4* (4), Extras: 0, Kagiso Rabada 3 (3)</li>
                      </ul>
                    </div>
                    {/* Bowling Scorecard */}
                    <h2 className="mb-4 text-xl font-bold text-center text-blue-700">Bowling Scorecard</h2>
                    <div className="overflow-x-auto">
                      <table className="min-w-full text-sm text-left">
                        <thead>
                          <tr className="bg-blue-100">
                            <th className="px-4 py-2 font-bold">Bowler</th>
                            <th className="px-4 py-2 font-bold">O</th>
                            <th className="px-4 py-2 font-bold">M</th>
                            <th className="px-4 py-2 font-bold">R</th>
                            <th className="px-4 py-2 font-bold">W</th>
                            <th className="px-4 py-2 font-bold">Econ</th>
                            <th className="px-4 py-2 font-bold">Dots</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="px-4 py-2">Jacob Duffy</td>
                            <td className="px-4 py-2">4</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">38</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">9.5</td>
                            <td className="px-4 py-2">6</td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2">Bhuvneshwar Kumar</td>
                            <td className="px-4 py-2">4</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">29</td>
                            <td className="px-4 py-2">2</td>
                            <td className="px-4 py-2">7.25</td>
                            <td className="px-4 py-2">11</td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2">Josh Hazlewood</td>
                            <td className="px-4 py-2">4</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">37</td>
                            <td className="px-4 py-2">2</td>
                            <td className="px-4 py-2">9.25</td>
                            <td className="px-4 py-2">7</td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2">Rasikh Dar</td>
                            <td className="px-4 py-2">4</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">27</td>
                            <td className="px-4 py-2">3</td>
                            <td className="px-4 py-2">6.75</td>
                            <td className="px-4 py-2">8</td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2">Krunal Pandya</td>
                            <td className="px-4 py-2">4</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">23</td>
                            <td className="px-4 py-2">1</td>
                            <td className="px-4 py-2">5.75</td>
                            <td className="px-4 py-2">7</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                {/* Royal Challengers Bengaluru Batting & Bowling Scorecard Card */}
                <div className="w-full mt-8">
                  <div className="p-6 bg-white shadow dark:bg-secondary-dark-bg rounded-2xl">
                    <h2 className="mb-4 text-xl font-bold text-center text-red-700">Royal Challengers Bengaluru Batting Scorecard</h2>
                    <h2 className="mb-4 text-xl font-bold text-center text-red-700">Overs (18.0) 161/5</h2>
                    <div className="mb-6 overflow-x-auto">
                      <table className="min-w-full text-sm text-left">
                        <thead>
                          <tr className="bg-red-100">
                            <th className="px-4 py-2 font-bold">Batter</th>
                            <th className="px-4 py-2 font-bold">How Out</th>
                            <th className="px-4 py-2 font-bold">R</th>
                            <th className="px-4 py-2 font-bold">B</th>
                            <th className="px-4 py-2 font-bold">4s</th>
                            <th className="px-4 py-2 font-bold">6s</th>
                            <th className="px-4 py-2 font-bold">SR</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="px-4 py-2">Venkatesh Iyer</td>
                            <td className="px-4 py-2">c Kagiso Rabada b Mohammed Siraj</td>
                            <td className="px-4 py-2">32</td>
                            <td className="px-4 py-2">16</td>
                            <td className="px-4 py-2">4</td>
                            <td className="px-4 py-2">2</td>
                            <td className="px-4 py-2">200.00</td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2">Virat Kohli</td>
                            <td className="px-4 py-2">not out</td>
                            <td className="px-4 py-2">75</td>
                            <td className="px-4 py-2">42</td>
                            <td className="px-4 py-2">9</td>
                            <td className="px-4 py-2">3</td>
                            <td className="px-4 py-2">178.57</td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2">Devdutt Padikkal</td>
                            <td className="px-4 py-2">c Mohd Arshad Khan b Kagiso Rabada</td>
                            <td className="px-4 py-2">1</td>
                            <td className="px-4 py-2">4</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">25.00</td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2">Rajat Patidar (c)</td>
                            <td className="px-4 py-2">c Kagiso Rabada b Rashid Khan</td>
                            <td className="px-4 py-2">15</td>
                            <td className="px-4 py-2">13</td>
                            <td className="px-4 py-2">1</td>
                            <td className="px-4 py-2">1</td>
                            <td className="px-4 py-2">115.38</td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2">Krunal Pandya</td>
                            <td className="px-4 py-2">lbw Rashid Khan</td>
                            <td className="px-4 py-2">1</td>
                            <td className="px-4 py-2">2</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">50.00</td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2">Tim David</td>
                            <td className="px-4 py-2">c Jos Buttler b Mohd Arshad Khan</td>
                            <td className="px-4 py-2">24</td>
                            <td className="px-4 py-2">17</td>
                            <td className="px-4 py-2">3</td>
                            <td className="px-4 py-2">1</td>
                            <td className="px-4 py-2">141.18</td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2">Jitesh Sharma (wk)</td>
                            <td className="px-4 py-2">not out</td>
                            <td className="px-4 py-2">11</td>
                            <td className="px-4 py-2">14</td>
                            <td className="px-4 py-2">1</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">78.57</td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2 font-bold">Extras</td>
                            <td className="px-4 py-2">(nb 0, w 1, b 0, lb 1, pen 0)</td>
                            <td className="px-4 py-2">2</td>
                            <td className="px-4 py-2"></td>
                            <td className="px-4 py-2"></td>
                            <td className="px-4 py-2"></td>
                            <td className="px-4 py-2"></td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2 font-bold">Did Not Bat:</td>
                            <td className="px-4 py-2" colSpan={6}>Romario Shepherd, Bhuvneshwar Kumar, Josh Hazlewood, Jacob Duffy, Rasikh Dar</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    {/* Fall of Wickets */}
                    <h2 className="mt-8 mb-2 text-lg font-bold text-red-700">Fall of Wickets</h2>
                    <div className="mb-4 text-sm text-gray-800">
                      <ul className="ml-6 list-disc">
                        <li>1-62 Venkatesh Iyer (Over 4.3)</li>
                        <li>2-63 Devdutt Padikkal (Over 5.1)</li>
                        <li>3-89 Rajat Patidar (Over 8.2)</li>
                        <li>4-91 Krunal Pandya (Over 8.5)</li>
                        <li>5-132 Tim David (Over 13.6)</li>
                      </ul>
                    </div>
                    {/* Partnership Info */}
                    <h2 className="mb-2 text-lg font-bold text-red-700">Partnerships</h2>
                    <div className="mb-4 text-sm text-gray-800">
                      <ul className="ml-6 list-disc">
                        <li>Venkatesh Iyer 32 (16) &mdash; Partnership: 62 (27), Extras: 1, Virat Kohli 29 (11)</li>
                        <li>Virat Kohli 0 (0) &mdash; Partnership: 1 (4), Extras: 0, Devdutt Padikkal 1 (4)</li>
                        <li>Rajat Patidar 15 (13) &mdash; Partnership: 26 (19), Extras: 1, Virat Kohli 10 (6)</li>
                        <li>Krunal Pandya 1 (2) &mdash; Partnership: 2 (3), Extras: 0, Virat Kohli 1 (1)</li>
                        <li>Tim David 24 (17) &mdash; Partnership: 41 (31), Extras: 0, Virat Kohli 17 (14)</li>
                        <li>Virat Kohli 18 (10) &mdash; Partnership: 29* (24), Extras: 0, Jitesh Sharma 11 (14)</li>
                      </ul>
                    </div>
                    {/* Bowling Scorecard */}
                    <h2 className="mb-4 text-xl font-bold text-center text-red-700">Bowling Scorecard</h2>
                    <div className="overflow-x-auto">
                      <table className="min-w-full text-sm text-left">
                        <thead>
                          <tr className="bg-red-100">
                            <th className="px-4 py-2 font-bold">Bowler</th>
                            <th className="px-4 py-2 font-bold">O</th>
                            <th className="px-4 py-2 font-bold">M</th>
                            <th className="px-4 py-2 font-bold">R</th>
                            <th className="px-4 py-2 font-bold">W</th>
                            <th className="px-4 py-2 font-bold">Econ</th>
                            <th className="px-4 py-2 font-bold">Dots</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="px-4 py-2">Mohammed Siraj</td>
                            <td className="px-4 py-2">4</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">36</td>
                            <td className="px-4 py-2">1</td>
                            <td className="px-4 py-2">9</td>
                            <td className="px-4 py-2">10</td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2">Kagiso Rabada</td>
                            <td className="px-4 py-2">3</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">44</td>
                            <td className="px-4 py-2">1</td>
                            <td className="px-4 py-2">14.67</td>
                            <td className="px-4 py-2">7</td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2">Jason Holder</td>
                            <td className="px-4 py-2">2</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">16</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">8</td>
                            <td className="px-4 py-2">5</td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2">Rashid Khan</td>
                            <td className="px-4 py-2">4</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">25</td>
                            <td className="px-4 py-2">2</td>
                            <td className="px-4 py-2">6.25</td>
                            <td className="px-4 py-2">9</td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2">Mohd Arshad Khan</td>
                            <td className="px-4 py-2">4</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">32</td>
                            <td className="px-4 py-2">1</td>
                            <td className="px-4 py-2">8</td>
                            <td className="px-4 py-2">9</td>
                          </tr>
                          <tr>
                            <td className="px-4 py-2">Prasidh Krishna</td>
                            <td className="px-4 py-2">1</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">7</td>
                            <td className="px-4 py-2">0</td>
                            <td className="px-4 py-2">7</td>
                            <td className="px-4 py-2">3</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                {/* End RCB Batting & Bowling Scorecard Card */}

                {/* Match Details Card */}
                <div className="w-full mt-8">
                  <div className="p-6 bg-white shadow dark:bg-secondary-dark-bg rounded-2xl">
                    <h2 className="mb-4 text-xl font-bold text-center text-gray-700">Match Details</h2>
                    <div className="mb-2 text-base text-gray-800">
                      <div><span className="font-bold">Tournament:</span> TATA IPL 2026</div>
                      <div><span className="font-bold">Match:</span> Royal Challengers Bengaluru vs Gujarat Titans</div>
                      <div><span className="font-bold">Toss Details:</span> Royal Challengers Bengaluru Won The Toss And Elected To Field</div>
                      <div><span className="font-bold">Venue:</span> Narendra Modi Stadium, Ahmedabad</div>
                      <div><span className="font-bold">On Field Umpires:</span> Nitin Menon, Kn Ananthapadmanabhan</div>
                      <div><span className="font-bold">Third Umpire:</span> J Madanagopal</div>
                      <div><span className="font-bold">Referee:</span> Javagal Srinath</div>
                      <div><span className="font-bold">MOM:</span> Virat Kohli (Royal Challengers Bengaluru)</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default LiveScore;
